import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./Pages/Home/Homescreen";

function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center space-y-6">
        <h1 className="font-display text-9xl font-bold text-black">404</h1>
        <p className="font-body text-xl text-black/50">
          Page not found
        </p>
        <Link
          to="/"
          className="inline-block font-body font-semibold bg-black text-white px-8 py-4 rounded-xl
                     hover:bg-black/80 transition-all duration-200"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
